import { Injectable } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable, forkJoin, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { StorageService } from './_services/storage.service';
import { switchMap, map } from 'rxjs/operators';
import { ApiService } from './_services/api.service';
import { environment } from '../../environments/environment';
import { isPlatformBrowser } from '@angular/common';
import { getOrigin, isSSR } from './util';
//import { getOrigin } from './util';


@Injectable()
export class CustomTranslateLoader implements TranslateLoader {

  constructor(private http: HttpClient, platformId: string) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  isBrowser = false;

  getTranslation(lang: string): Observable<any> {
    const s1 = isSSR() ? this.http.get(`${getOrigin()}/assets/locales/${lang}.json`) : of([]); // Le traduzioni delle rotte non servono per il prerendering
    const s2 = this.getMappone(lang);

    return forkJoin([s1, s2]).pipe( map(([traduzioniRotte, mappa]) => ({...traduzioniRotte, ...mappa.traduzioni})));
  }

  getMappone(language) {
    if (this.isBrowser && sessionStorage.getItem('superServizio_' + language)) {
      return of(JSON.parse(sessionStorage.getItem('superServizio_' + language)));
    } else {
      return this.http.post(environment.apiUrl + 'sito/superServizio', { language }).pipe(map((res: any) => {
        if (this.isBrowser) {
          sessionStorage.setItem('superServizio_' + language, JSON.stringify(res.result));
        }
        return res.result;
      }));
    }
  }
}
